import { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import "./shared.css"
import "./footer-modern.css"
import { GlobalContext } from '../../_helpers/GlobalState';


export function Footer() {
    const { WebsiteData } = useContext(GlobalContext);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    return (
        <>
            {/* Modern Call to Action Section */}
            <section className="modern-cta-section">
                <div className="cta-background">
                    <div className="cta-overlay"></div>
                </div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8 col-md-7">
                            <div className="cta-content">
                                <h2 className="cta-title">{WebsiteData?.Website?.Footer?.TopParagraph}</h2>
                                <p className="cta-subtitle">Get in touch with our expert team today</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5 text-right">
                            <Link to="/Contact" className="btn-cta-modern">
                                <span>Contact Us Now</span>
                                <i className="fas fa-arrow-right"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Modern Footer */}
            <footer className="modern-footer">
                <div className="footer-main">
                    <div className="container">
                        <div className="row">
                            {/* Company Info */}
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="footer-widget">
                                    <div className="footer-logo">
                                        <img src={WebsiteData?.Website?.Footer?.logoUrl} alt="RKG Tech Logo" />
                                    </div>
                                    <div className="footer-about">
                                        <p>{WebsiteData?.Website?.Footer?.Description}</p>
                                    </div>
                                    <div className="footer-social">
                                        <h5>Follow Us</h5>
                                        <div className="social-links">
                                            <a href="#" className="social-link">
                                                <i className="fab fa-facebook-f"></i>
                                            </a>
                                            <a href="#" className="social-link">
                                                <i className="fab fa-linkedin-in"></i>
                                            </a>
                                            <a href="#" className="social-link">
                                                <i className="fab fa-instagram"></i>
                                            </a>
                                            <a href="#" className="social-link">
                                                <i className="fab fa-twitter"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Office Locations */}
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="footer-widget">
                                    <h4 className="widget-title">Our Locations</h4>
                                    <div className="location-item">
                                        <div className="location-icon">
                                            <i className="fas fa-map-marker-alt"></i>
                                        </div>
                                        <div className="location-content">
                                            <h5>{WebsiteData?.Website?.Footer?.OfficeOne?.Header}</h5>
                                            <p>{WebsiteData?.Website?.Footer?.OfficeOne?.Address}</p>
                                        </div>
                                    </div>
                                    <div className="location-item">
                                        <div className="location-icon">
                                            <i className="fas fa-map-marker-alt"></i>
                                        </div>
                                        <div className="location-content">
                                            <h5>{WebsiteData?.Website?.Footer?.OfficeTwo?.Header}</h5>
                                            <p>{WebsiteData?.Website?.Footer?.OfficeTwo?.Address}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Contact Info */}
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="footer-widget">
                                    <h4 className="widget-title">{WebsiteData?.Website?.Footer?.Contact?.Header}</h4>
                                    <div className="contact-list">
                                        {WebsiteData?.Website?.Footer?.Contact?.ContactList?.map((item, index) => (
                                            <div key={index} className="contact-item">
                                                <div className="contact-icon">
                                                    <i className={index === 0 ? "fas fa-phone" : index === 1 ? "fas fa-envelope" : "fas fa-globe"}></i>
                                                </div>
                                                <div className="contact-content">
                                                    <a href={index === 0 ? `tel:${item}` : index === 1 ? `mailto:${item}` : `https://${item}`}>
                                                        {item}
                                                    </a>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    
                                    {/* Quick Links */}
                                    <div className="quick-links">
                                        <h5>Quick Links</h5>
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><Link to="/about">About Us</Link></li>
                                            <li><Link to="/our-services">Services</Link></li>
                                            <li><Link to="/contact">Contact</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-8 col-md-7">
                                <div className="copyright">
                                    <p>&copy; 2025 RKG Technical Services. All Rights Reserved</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-5 text-right">
                                <button onClick={scrollToTop} className="scroll-to-top-modern">
                                    <i className="fas fa-chevron-up"></i>
                                    <span>Back to Top</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}
